<template>
  <div class="raporty">
    <rainbow-header #rainbowHeader></rainbow-header>
    <div v-show="widoczny" class="lds-dual-ring"></div>
    <TabelaObrotow @test="laduje"/>
  </div>
</template>

<script>
import travellaHeader from "./TravellaHeader";
import TabelaObrotow from "./TabelaObrotow";

export default {
  name: "Raporty",
  components: {
    TabelaObrotow
  },
  data: function() {
    return {
      widoczny: 0,
    };
  },
  methods: {
    laduje() {
      this.$nextTick(function() {
        if (this.widoczny == 0) {
          this.widoczny = 1;
        } else {
          this.widoczny = 0;
        }
      });
    }
  },
  mounted: function() {
    this.$nextTick(() => {
      travellaHeader.loadHeader();
    });
  }
};
</script>

<style>
.raporty {
  background-color: #eee;
  padding-bottom: 100px;
}
#raport-obrotow {
  z-index: 1;
}
.lds-dual-ring {
  z-index: 3;
  display: inline-block;
  width: 64px;
  height: 0px;
}
.lds-dual-ring:after {
  content: " ";
  display: block;
  width: 156px;
  height: 156px;
  margin-top: 250px;
  border-radius: 50%;
  border: 5px solid yellowgreen;
  border-color: yellowgreen transparent yellowgreen transparent;
  animation: lds-dual-ring 1.2s linear infinite;
}
@keyframes lds-dual-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>